



export const orgId = {
  label: "Organization Id",
  type: "string",
  "minLength": 1
};

export const domain = {
  label: "Domain",
  type: "string",
  minLength: 3
};


export const domainId = {
  label: "Domain Id",
  type: "string",
  "minLength": 1
};

export const email = {
  label: "Email",
  type: "string",
};
